/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { isNil } from "lodash";

export const getStringFromArray = (arr: unknown[], separator = " "): string =>
  arr
    .reduce<string[]>((acc, part) => {
      if (isNil(part) || part === "") {
        return acc;
      }

      const trimmed = `${part}`.trim();
      if (trimmed.length > 0) {
        acc.push(trimmed);
      }

      return acc;
    }, [])
    .join(separator);

export const getInitialsFromArray = (arr: unknown[]): string =>
  arr
    .reduce<string[]>((acc, part) => {
      if (isNil(part) || part === "") {
        return acc;
      }

      const trimmed = `${part}`.trim();
      if (trimmed.length > 0) {
        acc.push(trimmed.charAt(0));
      }

      return acc;
    }, [])
    .join("");
